import { render, staticRenderFns } from "./UserLeftSidebar.vue?vue&type=template&id=ef0035f4"
import script from "./UserLeftSidebar.vue?vue&type=script&lang=js"
export * from "./UserLeftSidebar.vue?vue&type=script&lang=js"
import style0 from "./UserLeftSidebar.vue?vue&type=style&index=0&id=ef0035f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports